export const TICKET_STATUS = {
  OPEN: 'OPEN',
  HIDDEN: 'HIDDEN',
  CLOSED: 'CLOSED'
};

export const EVENT_TYPE = {
  FREE: 'FREE',
  TICKET: 'TICKET',
  SCREENING: 'SCREENING'
};

export const ROLE = {
  MANAGER: 'Manager',
  PARTICIPANT: 'Participant',
  JUDGE: 'Judge',
  MENTOR: 'Mentor',
  VOLUNTEER: 'Volunteer',
  LOGGEDIN_USER: 'LoggedInUser',
  NO_ROLE: 'NoRole'
};

export const Introduction = {
  videoUrl: 'https://hackhub.s3-us-west-2.amazonaws.com/Hackhub+Tutorial+(1).mp4'
};



// WEBPACK FOOTER //
// ./src/components/cms/constant.js